module.exports = __webpack_public_path__ + "img/Icon awesome-facebook-f.ac1d701f.svg";